import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { push } from 'connected-react-router';
import { useDispatch } from 'react-redux';
import ProjectParticipations from './components/ProjectParticipations';
import ConnectedProjectProfileDialog from './components/ConnectedProjectProfileDialog';
import { setDocumentsDefaultProjectId } from '../../utils/documentsDefaultProjectId';

const Container = ({ match }) => {
  const dispatch = useDispatch();

  const {
    params: { projectId },
  } = match;

  const handleOnSubmitted = useCallback(
    ({ recipientId }) => {
      setDocumentsDefaultProjectId(recipientId, projectId);
      dispatch(push(`/patients/${recipientId}`));
    },
    [dispatch, projectId],
  );

  return (
    <>
      <ConnectedProjectProfileDialog
        projectId={projectId}
        onSubmitted={handleOnSubmitted}
      />
      <ProjectParticipations projectId={projectId} />
    </>
  );
};

Container.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      projectId: PropTypes.string.isRequired,
    }),
  }).isRequired,
};

export default Container;
